"use client";

import { useSelector } from "@xstate/react";
import { useContext } from "react";
import type { ActorRefFrom, SnapshotFrom } from "xstate";
import { SchedulerMachineContext } from "@/app/contextProviders/scheduler-machine-provider";
import type { schedulerMachine } from "@/lib/machines/schedulerMachine";
type SchedulerActorRef = ActorRefFrom<typeof schedulerMachine>;
type SchedulerSnapshot = SnapshotFrom<typeof schedulerMachine>;

/**
 * Returns the raw actor ref for sending events.
 * Throws if used outside SchedulerMachineProvider.
 */
export function useSchedulerActor() {
  const actorRef = useContext(SchedulerMachineContext);
  if (!actorRef) {
    throw new Error("useSchedulerActor must be used within SchedulerMachineProvider");
  }
  return actorRef;
}

/**
 * Reactive state selector — only re-renders when selected value changes.
 * Follows the same pattern as schedule-consultation.
 */
export function useSchedulerSelector(selector, compare) {
  const actorRef = useSchedulerActor();
  return useSelector(actorRef, selector, compare);
}